function removeSpecialCharacters(stringVal) {
    stringVal = stringVal.replace(/'/g, "''")
    return stringVal;
}
module.exports = removeSpecialCharacters;